// E-Learning Simple Form Handler (creates user posts)
jQuery(document).ready(function ($) {

    var elearningAuth = {
        storageKey: 'elearning_user',
        restUrl: (window.elearningAjax && window.elearningAjax.restUrl) || '/wp-json/elearning/v1/',
        ajaxUrl: (window.elearningAjax && window.elearningAjax.ajaxUrl) || '/wp-admin/admin-ajax.php',

        // Initialize auth system
        init: function() {
            console.log('Auth script loaded');
            console.log('window.elearningAjax:', window.elearningAjax);
            console.log('REST URL:', this.restUrl);
            console.log('AJAX URL (fallback):', this.ajaxUrl);
            console.log('Is logged in:', this.isLoggedIn());
            
            // Extra debugging for the API URLs
            if (!window.elearningAjax) {
                console.error('elearningAjax object not found!');
            } else {
                console.log('elearningAjax.restUrl:', window.elearningAjax.restUrl);
                console.log('elearningAjax.ajaxUrl:', window.elearningAjax.ajaxUrl);
                console.log('elearningAjax.nonce:', window.elearningAjax.nonce);
            }
            
            // Test AJAX endpoint
            this.testAjaxEndpoint();
            
            if (this.isLoggedIn()) {
                this.showContent();
                this.updateModuleBlocks();
            } else {
                this.showLogin();
            }
            
            this.handleLoginForm();
            this.handleLogout();
        },

        // Test if REST API endpoint is working
        testAjaxEndpoint: function() {
            var self = this;
            console.log('Testing REST API endpoint with Axios...');
            
            axios.post(self.restUrl + 'test', {}, {
                headers: {
                    'X-WP-Nonce': (window.elearningAjax && window.elearningAjax.nonce) || ''
                }
            })
                .then(function(response) {
                    console.log('Axios REST API test - Success:', response.data);
                })
                .catch(function(error) {
                    console.error('Axios REST API test - Error:', { 
                        error: error, 
                        response: error.response,
                        url: self.restUrl + 'test'
                    });
                });
        },

        // Session helpers
        getUser: function() {
            try {
                return JSON.parse(localStorage.getItem(this.storageKey));
            } catch (e) {
                return null;
            }
        },

        setUser: function(user) {
            localStorage.setItem(this.storageKey, JSON.stringify(user));
        },

        clearUser: function() {
            localStorage.removeItem(this.storageKey);
        },

        isLoggedIn: function() {
            var user = this.getUser();
            return user && user.uid;
        },

        // UI helpers
        showLogin: function() {
            $('.module-login-section, .login-section').show();
            $('.module-content-section, .module-section').hide();
        },

        showContent: function() {
            $('.module-login-section, .login-section').hide();
            $('.module-content-section, .module-section').show();
        },

        // Login form handler
        handleLoginForm: function() {
            var self = this;
            console.log('Setting up login form handler...');
            
            var $form = $('#login-form');
            console.log('Login form found:', $form.length > 0 ? $form : 'NOT FOUND');
            
            if ($form.length === 0) {
                console.error('Login form not found!');
                return;
            }
            
            $form.on('submit', function(e) {
                e.preventDefault();
                console.log('Form submitted - processing...');
                
                // Get form fields
                var $nameField = $form.find('[name="field_name"]');
                var $companyField = $form.find('[name="field_company"]');
                var $emailField = $form.find('[name="field_email"]');
                
                console.log('Form fields found:', {
                    name: $nameField.length > 0,
                    company: $companyField.length > 0,
                    email: $emailField.length > 0
                });
                
                if ($nameField.length === 0 || $companyField.length === 0 || $emailField.length === 0) {
                    console.error('Form fields not found!');
                    alert('Form fields not found. Please check the form structure.');
                    return;
                }
                
                var name = $nameField.val().trim();
                var company = $companyField.val().trim();
                var email = $emailField.val().trim();
                
                console.log('Form data:', { name: name, company: company, email: email });
                
                if (!name || !company || !email) {
                    alert('Vul alle velden in aub.');
                    return;
                }
                
                                 // Create user post via REST API
                 var requestData = {
                     field_name: name,
                     field_company: company,
                     field_email: email
                 };
                 
                 console.log('Sending Axios REST API request to:', self.restUrl + 'login');
                 console.log('Request data being sent:', requestData);
                 
                 axios.post(self.restUrl + 'login', requestData, {
                     headers: {
                         'Content-Type': 'application/json',
                         'X-WP-Nonce': (window.elearningAjax && window.elearningAjax.nonce) || ''
                     }
                 })
                 .then(function(response) {
                     console.log('Axios REST API response received:', response);
                     console.log('Response data:', response.data);
                     console.log('Response data type:', typeof response.data);
                     
                     // REST API returns data directly, not wrapped in success/data
                     if (response.data && response.data.uid) {
                         console.log('Login successful! Storing user data...');
                         console.log('User data to store:', response.data);
                         
                         // Store user data
                         self.setUser(response.data);
                         
                         // Verify data was stored
                         var storedUser = self.getUser();
                         console.log('Stored user data verification:', storedUser);
                         console.log('localStorage check:', localStorage.getItem(self.storageKey));
                         
                         self.showContent();
                         self.updateModuleBlocks();
                         alert('Login successful!');
                     } else {
                         console.error('Login failed: Invalid response format', response.data);
                         alert('Login mislukt - invalid response.');
                     }
                 })
                 .catch(function(error) {
                     console.error('Axios login request failed:', error);
                     if (error.response) {
                         console.error('Error response:', error.response.data);
                         console.error('Error status:', error.response.status);
                     }
                     alert('Er is een fout opgetreden. Probeer het opnieuw.');
                 });
            });
        },

        // Logout handler
        handleLogout: function() {
            var self = this;
            $('.logout-button').on('click', function(e) {
                e.preventDefault();
                self.clearUser();
                self.showLogin();
            });
        },

        // Module completion
        markModuleCompleted: function(courseId, moduleId) {
            var user = this.getUser();
            if (!user) return;
            if (!user.progress) user.progress = [];
            
            var existingProgress = user.progress.find(function(p) {
                return p.course_id == courseId && p.module_id == moduleId;
            });
            
            if (!existingProgress) {
                user.progress.push({ 
                    course_id: courseId, 
                    module_id: moduleId, 
                    completed_at: new Date().toISOString() 
                });
                this.setUser(user);
            }
        },

        hasCompletedModule: function(courseId, moduleId) {
            var user = this.getUser();
            if (!user || !user.progress) return false;
            
            return user.progress.some(function(p) {
                return p.course_id == courseId && p.module_id == moduleId;
            });
        },

        // Update module blocks UI
        updateModuleBlocks: function() {
            var self = this;
            $('.block--module').each(function() {
                var $block = $(this);
                var courseId = $block.data('course-id') || $block.attr('data-course-id');
                var moduleId = $block.data('module-id') || $block.attr('data-module-id');
                
                if (self.hasCompletedModule(courseId, moduleId)) {
                    $block.addClass('block--module-done');
                } else {
                    $block.removeClass('block--module-done');
                }
            });
        }
    };

    // Initialize auth system
    elearningAuth.init();

    // Expose for debugging and external access
    window.elearningAuth = elearningAuth;

}); 